<template>
    <!-- 工程建设质量管理小组竞赛活动 -->
    <div ref="previewDom" class="a4 preview-7--container">
        <table class="preview-7--table" cellspacing="0" cellpadding="0" border="0">
            <tbody>
                <tr>
                    <td width="150">
                        <p><strong>企业名称</strong></p>
                    </td>
                    <td width="386">
                        <p><strong>{{ alldata.company }}</strong></p>
                    </td>
                </tr>
                <tr>
                    <td width="150">
                        <p><strong>小组名称</strong></p>
                    </td>
                    <td width="386">
                        <p><strong>{{ alldata.group }}</strong></p>
                    </td>
                </tr>
                <tr>
                    <td width="150">
                        <p><strong>小组人数</strong></p>
                    </td>
                    <td width="386">
                        <p><strong>{{ alldata.group_people_num }}</strong></p>
                    </td>
                </tr>
                <tr>
                    <td width="150">
                        <p><strong>小组成员</strong></p>
                    </td>
                    <td width="386">
                        <p><strong>{{ alldata.group_people }}</strong></p>
                    </td>
                </tr>
                <tr>
                    <td width="150">
                        <p><strong>课题名称</strong></p>
                    </td>
                    <td width="386">
                        <p><strong>{{ alldata.project_title }}</strong></p>
                    </td>
                </tr>
                <tr>
                    <td width="150">
                        <p><strong>课题类型</strong></p>
                    </td>
                    <td width="386">
                        <p><strong>{{ alldata.project_type }}</strong></p>
                    </td>
                </tr>
                <tr>
                    <td width="150">
                        <p><strong>工程名称</strong></p>
                    </td>
                    <td width="386">
                        <p><strong>{{ alldata.work_name }}</strong></p>
                    </td>
                </tr>
                <tr>
                    <td width="150">
                        <p><strong>工程类别</strong></p>
                    </td>
                    <td width="386">
                        <p><strong>{{ alldata.work_type }}</strong></p>
                    </td>
                </tr>
                <tr>
                    <td width="150">
                        <p><strong>工程所在地</strong></p>
                    </td>
                    <td width="386">
                        <p><strong>{{ alldata.work_address }}</strong></p>
                    </td>
                </tr>
                <tr>
                    <td width="150">
                        <p><strong>小组活动推进者姓名</strong></p>
                    </td>
                    <td width="386">
                        <p><strong>{{ alldata.work_user_name }}</strong></p>
                    </td>
                </tr>
                <tr>
                    <td width="150">
                        <p><strong>小组活动结束时间</strong></p>
                    </td>
                    <td width="386">
                        <p><strong>{{ alldata.end_time }}</strong></p>
                    </td>
                </tr>
                <tr>
                    <td width="150">
                        <p><strong>推进者培训结业证书颁发机构</strong></p>
                    </td>
                    <td width="386">
                        <p><strong>{{ alldata.guide_org }}</strong></p>
                    </td>
                </tr>
                <tr>
                    <td width="150">
                        <p><strong>联系人</strong></p>
                    </td>
                    <td width="386">
                        <p><strong>{{ alldata.linker == undefined ? '' :  alldata.linker }}</strong></p>
                    </td>
                </tr>
                <tr>
                    <td width="150">
                        <p><strong>联系电话</strong></p>
                    </td>
                    <td width="386">
                        <p><strong>{{ alldata.tel == undefined ? '' :  alldata.tel }}</strong></p>
                    </td>
                </tr>
                <tr>
                    <td rowspan="7" width="150">
                        <p><strong>活动上传材料</strong></p>
                    </td>
                    <td width="386">
                        <p>
                            <a v-if="getUrl('reportforms')" target="_blank" :href="getUrl('reportforms')">
                                工程建设质量管理小组竞赛活动成果报名表
                            </a>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="386">
                        <p>
                            <a v-if="getUrl('reportfiles')" target="_blank" :href="getUrl('reportfiles')">
                                工程建设质量管理小组竞赛活动成果汇总表
                            </a>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="386">
                        <p>
                            <a v-if="getUrl('reportinfos')" target="_blank" :href="getUrl('reportinfos')">
                                质量管理小组活动成果电子版材料
                            </a>
                        </p>
                    </td>
                </tr>
                <tr v-if="alldata.reportjieye != undefined && getUrl('reportjieye')">
                    <td width="386">
                        <p>
                            <a v-if="getUrl('reportjieye')" target="_blank" :href="getUrl('reportjieye')">
                               推进者有效期内培训结业证书扫描件
                            </a>
                        </p>
                    </td>
                </tr>
                <tr v-if="alldata.reporthuizong != undefined && getUrl('reporthuizong')">
                    <td width="386">
                        <p>
                            <a v-if="getUrl('reporthuizong')" target="_blank" :href="getUrl('reporthuizong')">
                                近三年小组成员参与质量管理小组活动培训情况汇总表
                            </a>
                        </p>
                    </td>
                </tr>
                <tr v-if="alldata.reportchengnuo != undefined && getUrl('reportchengnuo')">
                    <td width="386">
                        <p>
                            <a v-if="getUrl('reportchengnuo')" target="_blank" :href="getUrl('reportchengnuo')">
                                企业承诺书
                            </a>
                        </p>
                    </td>
                </tr>
                <tr v-if="alldata.guidecerts.length > 0">
                    <td width="386">
                        <p v-for="(row, index) in alldata.guidecerts"
                           :key="index">
                            <a v-if="getUrl('guidecerts', index)" target="_blank" :href="getUrl('guidecerts', index)">
                                {{ `推进者证书扫描件或其他有效证明文件（${index + 1}）` }}
                            </a>
                        </p>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        alldata: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        getUrl(key, index = 0) {
            console.log('alldata.guidecerts',this.alldata.guidecerts)
            const fileList = this.alldata[key] || []
            const file = fileList[index]
            if (!file) {
                return ''
            }
            return file.url
        }
    }
}
</script>

<style lang="less" scoped>
.preview-7--container {
    td {
        border: 1px solid #d4dbdd;
        padding: 20px 10px;
    }
}
.preview-7--table {
    width: 100%;
    border-collapse: collapse;
}
.a4 h1, .a4 p {
    font-family: auto !important;
}
.wrap .a4{
    min-height: 1346px;
    height: auto !important;
}
</style>
